import axiosInterceptor from './axiosInterceptor';

const service = axiosInterceptor;

// export const getAPI = (path, config) =>
//   service.get(path, config).then((res) => res);

// export const postAPI = (path, requestData, config) =>
//   service.post(path, requestData, config).then((res) => res);

// export const patchAPI = (path, requestData, config) =>
//   service.patch(path, requestData, config).then((res) => res);

// export const deleteAPI = (path, requestData, config) =>
//   service.delete(path, requestData, config).then((res) => res);

// export const putAPI = (path, requestData, config) =>
//   service.put(path, requestData, config).then((res) => res);

export default service;
